import { Pipe, PipeTransform } from '@angular/core';
import { AmlStatus } from '@app/core/state/types/aml.types';

@Pipe({
  name: 'amlStatusToTranslationKey',
  standalone: true,
})
export class AmlStatusToTranslationKeyPipe implements PipeTransform {
  // eslint-disable-next-line complexity
  transform(value: AmlStatus | null, translationScope: string): string {
    switch (value) {
      case AmlStatus.IN_PROGRESS:
        return `${translationScope}.amlStatusInProgress`;
      case AmlStatus.WAITING_COLLEAGUE:
        return `${translationScope}.amlStatusWaitingColleague`;
      case AmlStatus.DONE_COLLEAGUE:
        return `${translationScope}.amlStatusDoneColleague`;
      case AmlStatus.WAITING_COLLEAGUE_APPROVAL:
        return `${translationScope}.amlStatusWaitingColleagueApproval`;
      case AmlStatus.WAITING_CLIENT:
        return `${translationScope}.amlStatusWaitingClient`;
      case AmlStatus.DONE_CLIENT:
        return `${translationScope}.amlStatusDoneClient`;
      case AmlStatus.DECLINED:
        return `${translationScope}.amlStatusDeclined`;
      case AmlStatus.DONE:
        return `${translationScope}.amlStatusDone`;
      default:
        return `${translationScope}.amlStatusUnknown`;
    }
  }
}
